module.exports = __webpack_public_path__ + "img/ai1.bcfa9eb3.png";